export const ChatEmpty = () => {
  return (
    <svg
      width={180}
      height={178}
      viewBox="0 0 486 378"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="No Chat History">
        <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M263.043 0C218.613 0 177.777 15.4012 145.533 41.1686H93.4199C86.6494 41.1686 81.1098 46.7264 81.1098 53.5192C81.1098 60.3121 86.6494 65.8698 93.4199 65.8698H119.942H127.714C134.484 65.8698 140.024 71.4276 140.024 78.2204C140.024 81.6127 138.637 84.7086 136.405 86.9399C134.181 89.1795 131.095 90.571 127.714 90.571H111.133H101.977H57.3102C50.5396 90.571 45 96.1288 45 102.922C45 109.714 50.5396 115.272 57.3102 115.272H89.287C79.6342 138.032 74.2875 163.075 74.2875 189.376C74.2875 198.919 74.9933 208.297 76.3474 217.461C76.9137 221.29 77.5948 225.085 78.3909 228.84C101.616 225.275 126.253 222.409 151.973 220.318L153.91 222.088L155.731 220.022C186.63 217.609 219.063 216.325 252.514 216.325C323.585 216.325 390.092 222.121 446.957 232.199C449.148 222.665 450.625 212.858 451.323 202.83C451.643 198.383 451.799 193.896 451.799 189.376C451.799 84.7827 367.294 0 263.043 0Z"
          fill="#F1F2F7"
        />
        <path
          id="Fill 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9301 89.9998H12.4698C5.61142 89.9998 0 95.6698 0 102.6C0 109.53 5.61142 115.2 12.4698 115.2H19.9301C26.7885 115.2 32.3999 109.53 32.3999 102.6C32.3999 95.6698 26.7885 89.9998 19.9301 89.9998Z"
          fill="#F1F2F7"
        />
        <g id="Group 7">
          <mask
            id="mask0_1626_19673"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x={78}
            y={216}
            width={408}
            height={162}
          >
            <path
              id="Clip 6"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M485.872 216.597V377.999H282.003H78.1348V216.597H485.872Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1626_19673)">
            <path
              id="Fill 5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M485.872 279C485.872 285.75 480.334 291.272 473.565 291.272H394.954C391.574 291.272 388.489 292.655 386.266 294.88C384.034 297.098 382.647 300.174 382.647 303.545C382.647 310.295 388.185 315.818 394.954 315.818H409.559C412.939 315.818 416.025 317.2 418.248 319.426C420.48 321.643 421.867 324.719 421.867 328.09C421.867 334.84 416.328 340.363 409.559 340.363H375.977C344.429 363.992 305.227 377.999 262.743 377.999C172.006 377.999 96.2263 314.14 78.1348 229.033C101.354 225.491 125.985 222.643 151.699 220.565L153.634 222.324L155.457 220.271C186.347 217.873 218.773 216.597 252.216 216.597C323.269 216.597 389.76 222.357 446.611 232.372C443.847 244.301 439.942 255.788 435.019 266.727H473.565C476.954 266.727 480.022 268.11 482.254 270.335C484.486 272.552 485.872 275.629 485.872 279Z"
              fill="#E8EBF2"
            />
          </g>
        </g>
        <path
          id="Fill 8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M449.998 202.27C449.301 212.49 447.826 222.483 445.638 232.199C388.849 221.929 322.429 216.023 251.453 216.023C218.046 216.023 185.656 217.331 154.799 219.79L176.198 194.995L209.487 216.719L254.551 204.276L332.073 216.023L365.728 204.276L374.252 216.023L394.588 200.928L413.592 218.346L443.564 194.4L449.998 202.27Z"
          fill="#E0E2EE"
        />
        <path
          id="Fill 10"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M339.516 213.119C348.04 200.728 352.923 186.034 352.797 170.308C352.449 126.569 313.484 91.4221 265.767 91.8028C218.051 92.1844 179.653 127.952 180.002 171.691C180.352 215.429 219.317 250.577 267.032 250.196C284.081 250.06 299.938 245.404 313.265 237.483L348.915 245.877L339.516 213.119Z"
          fill="#D8DBEA"
        />
        <path
          id="Fill 12"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M241.201 169.128C241.24 174.098 237.243 178.16 232.273 178.199C227.302 178.24 223.24 174.242 223.201 169.272C223.162 164.301 227.158 160.24 232.129 160.2C237.099 160.16 241.16 164.157 241.201 169.128Z"
          fill="#BEC0D6"
        />
        <path
          id="Fill 14"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M273.597 169.127C273.637 174.098 269.64 178.16 264.669 178.199C259.698 178.239 255.637 174.242 255.598 169.272C255.558 164.301 259.555 160.239 264.525 160.2C269.495 160.16 273.557 164.157 273.597 169.127Z"
          fill="#BEC0D6"
        />
        <path
          id="Fill 16"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M306 169.127C306.039 174.097 302.042 178.159 297.071 178.199C292.101 178.239 288.039 174.242 288 169.271C287.96 164.3 291.957 160.239 296.928 160.2C301.898 160.159 305.959 164.157 306 169.127Z"
          fill="#BEC0D6"
        />
        <path
          id="Fill 18"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.801 219.599L153.055 221.399L151.201 219.857C152.395 219.764 153.599 219.678 154.801 219.599Z"
          fill="#F1F2F7"
        />
        <path
          id="Fill 20"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M171 232.2C171 237.916 172.828 243.237 175.97 247.716L172.635 259.667L185.618 256.508C190.499 259.347 196.287 260.999 202.5 260.999C219.897 260.999 234 248.105 234 232.2C234 216.294 219.897 203.399 202.5 203.399C185.103 203.399 171 216.294 171 232.2Z"
          fill="#5B6B86"
        />
        <path
          id="Fill 22"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M210.598 232.2C210.598 234.188 212.208 235.799 214.197 235.799C216.185 235.799 217.798 234.188 217.798 232.2C217.798 230.212 216.185 228.599 214.197 228.599C212.208 228.599 210.598 230.212 210.598 232.2Z"
          fill="white"
        />
        <path
          id="Fill 24"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M199.799 232.2C199.799 234.188 201.41 235.799 203.399 235.799C205.386 235.799 206.999 234.188 206.999 232.2C206.999 230.212 205.386 228.599 203.399 228.599C201.41 228.599 199.799 230.212 199.799 232.2Z"
          fill="white"
        />
        <path
          id="Fill 26"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M187.201 232.2C187.201 234.188 188.813 235.799 190.801 235.799C192.789 235.799 194.401 234.188 194.401 232.2C194.401 230.212 192.789 228.599 190.801 228.599C188.813 228.599 187.201 230.212 187.201 232.2Z"
          fill="white"
        />
        <path
          id="Fill 28"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M151.197 220.064C125.486 222.158 100.858 225.028 77.6405 228.599C76.8447 224.839 76.1637 221.037 75.5977 217.202L115.394 187.199L151.197 220.064Z"
          fill="#E0E2EE"
        />
        <path
          id="Fill 30"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M331.198 281.699C331.198 285.179 299.769 287.999 260.999 287.999C222.228 287.999 190.799 285.179 190.799 281.699C190.799 278.221 222.228 275.399 260.999 275.399C299.769 275.399 331.198 278.221 331.198 281.699Z"
          fill="#D8DBEA"
        />
        <path
          id="Fill 32"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M446.399 340.199C439.469 340.199 433.799 334.529 433.799 327.599C433.799 320.669 439.469 314.999 446.399 314.999C453.329 314.999 458.999 320.669 458.999 327.599C458.999 334.529 453.329 340.199 446.399 340.199Z"
          fill="#E1E3EF"
        />
      </g>
    </svg>
  )
}
